import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const CheckRouterService = {
    CheckRouter
};

function CheckRouter() {
    let user_nbtc = Cookie.get('user_nbtc')
    try{
        JSON.parse(user_nbtc);
    }catch(e){
        return {status : 230,message : 'ไม่พบสิทธิ์การเข้าใช้งาน กรุณาเข้าสู่ระบบใหม่อีกครั้ง'}
    }
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "CheckRouter/index/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}